import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import Page from '../../../../page/index';
import { setScreen } from '../../../../../redux/connectedComponent/uiFactory/uiFactory.slice'
import { screens } from '../../../../config/uiFactory.config'
import SolutionHeader from '../../../SolutionHeader/SolutionHeader'
import { METADATA_CONSTANTS } from '../../../../../constants/metadataConstant'
import {
  Button,
  MultiToasts,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS,
  TOAST_VARIANTS
} from 'cdk-radial';
import { consentConstant } from '../../../../../constants/consentConstant';
import ConsentDialog from '../../../../common/ConsentDialog';
import { withRouter } from 'react-router-dom';
import './index.scss';
import {
  bulkConnectionDisable,
  bulkConnectionEnable,
  saveApiConsentForMultipleLocations,
  updateConsentSuccess,
  updateConsentfailed,
  updateSaveConsentSuccess,
  getUserDetailsForBulkConnection
} from '../../../../../redux/connectedComponent/manageBulkConnections/manageBulkConnectioins.slice';
import {
  getApiIntegrationsDetails
} from '../../../../../redux/connectedComponent/apiIntegrations/apiIntegration.slice';
import Overlay from '../../../../Overlay/Overlay';
import LoadingOverlaySpinner from '../../../../loader/LoadingOverlaySpinner'
import {clearUpdateDMSAccounts} from '../../../../../redux/connectedComponent/updateDMSAccounts/updateDMSAccounts.slice';
import {
  getDMSAccountDetailsFromEIS,
  getDMSInfoBasedOnApis,
  updateSelectedDMSAccounts,
  clearSelectedDMS
} from '../../../../../redux/connectedComponent/selectedDMS/selectedDMS.slice';
import {
  getCppForAppAndLocations,
  updateCppForApp
} from '../../../../../redux/connectedComponent/privacyProtection/privacyProtection.slice';
import DMSSelection from '../../../../stepper/stepperBody/stepperBodyComponents/DMSSelection';
import LearnMore from '../../../../LearnMore/LearnMore';
import Notice from '../../../../UI/Notice';
import { sendAmplitudeData } from '../../../../../utils/amplitude';
import { AMPLITUDE_EVENTS, AMPLITUDE_PROPERTIES } from '../../../../../constants/amplitudeConstants';
import LocationsTable from './LocationsTable';

const SAVING_CONNECTION_UPDATE_MSG =
  'Saving connection activation/deactivation request';

class ManageBulkConnections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toasts: [],
      connectionsDirty: false,
      cppDirty: false,
      locations: [],
      initializeToggleStatus: false,
      showAPIAddendum: false,
      enabledLocations: 0,
      disabledLocations: 0,
      enablePayload: {},
      disablePayload: {},
      newLocations: 0,
      enabledEntityIds: 0,
      doesApiRequireDMS: false,
      doesApiSupportCpp: false,
      loading: false,
      privacyProtectionOptOuts: {},
      originalOptOuts: {}
    };
    this.onBackButtonClickHandler = this.onBackButtonClickHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.createIntegrationsData = this.createIntegrationsData.bind(this);
    this.onDMSClose = this.onDMSClose.bind(this);
  }

  removeToast = toastId => {
    this.setState(ps => ({
      toasts: ps.toasts.filter(t => t.id !== toastId)
    }));
  };

  addToast = userDef => {
    const id = userDef.id || `${Math.random()}_${Date.now()}`.substring(2);
    const def = {
      visibilityDuration: TOAST_VISIBILITY_DURATIONS.SEVEN_SECONDS,
      ...userDef,
      id,
      onVisibilityDurationEnd: userDef.onVisibilityDurationEnd
        || (() => this.removeToast(id)),
      actions: userDef.actions || [{
        text: 'Dismiss',
        onClick: () => this.removeToast(id)
      }]
    };
    this.setState(ps => {
      return {
        toasts: [def, ...ps.toasts]
      };
    });
  };

  // predefined toast types for convenience.
  enableToast = () => this.addToast({
    content: (
      <div className="toast_notifications__content">
        API successfully enabled for {this.state.enabledLocations}{' '}
        location(s).
      </div>
    ),
    variant: TOAST_VARIANTS.POSITIVE
  });
  disableToast = () => this.addToast({
    content: (
      <div className="toast_notifications__content">
        API successfully disabled for {this.state.disabledLocations}{' '}
        location(s).
      </div>
    ),
    variant: TOAST_VARIANTS.POSITIVE
  });
  cppToast = () => this.addToast({
    content: (
      <div className="toast_notifications__content">
        Updated Consumer Privacy Protection settings.
      </div>
    ),
    variant: TOAST_VARIANTS.POSITIVE
  });
  enableFailedToast = () => this.addToast({
    content: (
      <div className="toast_notifications__content">
        Some error occurred while saving user request. Failed to
        enable API for {this.state.enabledLocations} location(s).
      </div>
    ),
    variant: TOAST_VARIANTS.NEGATIVE
  });
  disableFailedToast = () => this.addToast({
    content: (
      <div className="toast_notifications__content">
        Some error occurred while saving user request. Failed to
        disable API for {this.state.disabledLocations} location(s).
      </div>
    ),
    variant: TOAST_VARIANTS.NEGATIVE
  });
  cppFailedToast = () => this.addToast({
    content: (
      <div className='toast_notifications__content'>
        Failed to save Consumer Privacy Protection settings.
      </div>
    ),
    variant: TOAST_VARIANTS.NEGATIVE
  });

  initializeState = () => {
    let locationToggleStatus = [];
    if (this.props.additionalData.isBulkSubscribed) {
      localStorage.setItem(
        'locationToggleStatus',
        JSON.stringify(locationToggleStatus)
      );
      this.setState({ initializeToggleStatus: false });
    }
    const { locationsGroupByApi = {} } = this.props.ApiIntegrationsDetails;
    const locations =
      locationsGroupByApi[this.props.additionalData.apiDetails.api];
    let subscribedLocations = [];
    if (locations) {
      this.props.additionalData.subscriptionData.forEach((dsDealer, index) => {
        let flag = 0;
        locations.forEach((location) => {
          if (
            (location.entitycmfNumber &&  dsDealer.entitycmfNumber === location.entitycmfNumber) ||
            (location.entityId && dsDealer.entityId === location.entityId)
          ) {
            const { status, requested_status, createdOn, dmsAccount } =
              location;
            locationToggleStatus.push({
              locationIndex: index,
              toggleStatus: '',
              isRequestSent: '',
            });
            flag = 1;
            subscribedLocations.push({
              ...location,
              status: status,
              requested_status: requested_status,
              disabled: this.isPending(status, requested_status),
              createdOn: createdOn
                ? moment(createdOn).format('MM/DD/YYYY')
                : null,
              dmsAccount
            });
          }
        });
        if (flag === 0) {
          locationToggleStatus.push({
            locationIndex: index,
            toggleStatus: '',
            isRequestSent: '',
          });
          subscribedLocations.push({
            ...dsDealer,
            status: METADATA_CONSTANTS.STATUS.DISABLED,
            requested_status: METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE
          });
        }
      });
    } else {
     this.props.additionalData.subscriptionData.forEach((dealer,index)=>{
      locationToggleStatus.push({
        locationIndex: index,
        toggleStatus: '',
        isRequestSent: '',
      });
      subscribedLocations.push({
        ...dealer,
        status: METADATA_CONSTANTS.STATUS.DISABLED,
        requested_status: METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE,
      });
     })
    }
    this.setState({ locations: subscribedLocations });
    if (!this.state.initializeToggleStatus) {
      localStorage.setItem(
        'locationToggleStatus',
        JSON.stringify(locationToggleStatus)
      );
      this.setState({ initializeToggleStatus: true });
    }
  };

  checkApiSystemConfig = (additionalData, orgIds) => {
    // determine if the api requires dms account to be selected, and get
    // existing cpp entries if they exist
    const apiId = additionalData?.apiDetails?.id;
    const doesApiRequireDMS = this.props.dmsApiDetails.hasOwnProperty(apiId);
    const doesApiSupportCpp = this.props.privacyProtectionSupported[apiId] ?? false;

    // we only care about one api - and because of the way we fetch cpp
    // on this page, only that one api's id will be correct anyway.
    const optOutsAllApis = this.props.optOutsByLocation;
    const privacyProtectionOptOuts = {};
    for (const orgId of orgIds) {
      privacyProtectionOptOuts[orgId] = optOutsAllApis[orgId]?.[apiId] || false;
    }

    this.setState({
      doesApiRequireDMS,
      doesApiSupportCpp,
      privacyProtectionOptOuts,
      originalOptOuts: privacyProtectionOptOuts
    });
  };

  async componentDidMount() {
    this.props.clearUpdateDMSAccounts();
    let {
      solutionData,
      token,
      additionalData,
      getApiIntegrationsDetails,
      getDMSInfoBasedOnApis,
      getCppForAppAndLocations
    } = this.props;

    let {isBulkSubscribed, subscriptionData, apiDetails: {
      id,
      apiType
    }} = additionalData;

    const solutionId = solutionData.id;

    const entities = subscriptionData.map(
      (dealer) => dealer.entityId
    );

    let payload = { entities, solutionId, isBulkSubscribed: isBulkSubscribed };

    if (isBulkSubscribed && apiType === 'async-api') {
      let entityIdSubscriptionIdMapping = subscriptionData.map(data => ({
        entityId: data.entityId,
        subscriptionId: data.subscriptionId
      }));

      payload = {
        ...payload,
        apiId: id,
        apiType,
        entityIdSubscriptionIdMapping,
        asyncIntegrationId: solutionData?.registration_details?.api_details?.filter(api => api?.id === id)?.[0]?.asyncIntegrationId
      }
    }

    await getApiIntegrationsDetails({ payload, token });
    this.initializeState();

    let api = { id, apiType };
    await Promise.all([
      getDMSInfoBasedOnApis({ apis: [api], token: token }),
      getCppForAppAndLocations({
        appId: solutionId,
        // we're not going to examine privacyProtectionSlice.availableLocations
        // at all, so we don't care if it's incomplete. we just need the org id
        // for the fetch.
        locations: entities.map(entityId => ({ entityId })),
        // we only care about this one api, so only do the api-v2- prefix
        // compensation for it.
        apiDetails: [api],
        token
      })
    ]);
    this.checkApiSystemConfig(additionalData, entities);
  }

  async componentDidUpdate(prevProps) {
    let {
      enableSuccess,
      disableSuccess,
      enablePending,
      disablePending,
      enableFailed,
      disableFailed,
      solutionData,
      token,
      additionalData,
      updateConsentSuccess,
      getApiIntegrationsDetails,
      updateConsentfailed,
      issaveApiConsentSuccess,
      bulkConnectionEnable,
      updateSaveConsentSuccess,
      selectedDMS,
      updateCppPending,
      updateCppError
    } = this.props;

    const {
      enablePayload,
      disablePayload,
      locations
    } = this.state;
    const payload = JSON.parse(JSON.stringify(enablePayload))
    const dmsConfig ={}
    if(issaveApiConsentSuccess && Object.keys(enablePayload).length){
      if (selectedDMS.length) {
        if (additionalData.isBulkSubscribed) {
          const enabledLocations = this.getLocationsToBeEnabled(locations);
          enabledLocations.forEach((loc) => {
            let departments = [];
            const filtered = selectedDMS.filter(
              (dmsLoc) => dmsLoc.entityId === loc.entityId
            );
            filtered.forEach((dms) => {
              const filteredDepartments = dms.departments.map((dep) => ({
                ...dep,
                dmsType: dms.type,
              }));
              departments.push(...filteredDepartments);
            });
            let connectionId = loc.connectionId;
            if(additionalData?.apiDetails?.apiType === "async-api") {
              dmsConfig[loc.entityId] = departments;
            }
            else {
              dmsConfig[connectionId] = departments;
            }
          });
          payload.dmsConfig = dmsConfig;
        } else {
          payload.dmsAccount = selectedDMS.map((dms) => ({
            ...dms,
            api: payload.api,
          }));
        }
      }
      bulkConnectionEnable({ payload, token });
      updateSaveConsentSuccess()
      this.setState({ enablePayload: {} });
      this.props.clearSelectedDMS();
    }
    if (enablePending && Object.keys(disablePayload).length) {
      this.props.bulkConnectionDisable({ payload: disablePayload, token });
      this.setState({ disablePayload: {} });
    }
    if (
      (enableSuccess || disableSuccess) &&
      !(enablePending || disablePending)
    ) {
      this.setState({ loading: false });
      const solutionId = solutionData.id;
      const entities = additionalData.subscriptionData.map(
        (dealer) => dealer.entityId
      );
      let payload = { entities, solutionId, isBulkSubscribed: additionalData.isBulkSubscribed };

      let {isBulkSubscribed, subscriptionData, apiDetails: {
        id,
        apiType
      }} = additionalData;

      if (isBulkSubscribed && apiType === 'async-api') {
        let entityIdSubscriptionIdMapping = subscriptionData.map(data => ({
          entityId: data.entityId,
          subscriptionId: data.subscriptionId
        }));

        payload = {
          ...payload,
          apiId: id,
          apiType,
          entityIdSubscriptionIdMapping,
          asyncIntegrationId: solutionData?.registration_details?.api_details?.filter(api => api?.id === id)?.[0]?.asyncIntegrationId
        }
      }
      if (enableSuccess) {
        this.enableToast();
      }
      if (disableSuccess) {
        this.disableToast()
      }
      updateConsentSuccess();
      await getApiIntegrationsDetails({ payload, token });
      this.initializeState();
    }
    if (enableFailed || disableFailed) {
      this.setState({loading: false});
      if (enableFailed) {
        this.enableFailedToast();
      }
      if (disableFailed) {
        this.disableFailedToast();
      }
      updateConsentfailed();
      let locationToggleStatus = JSON.parse(
        localStorage.getItem('locationToggleStatus')
      );
      this.state.locations.forEach((location, index) => {
        locationToggleStatus[index] = {
          locationIndex: index,
          toggleStatus: '',
          isRequestSent: '',
        };
      });
      localStorage.setItem(
        'locationToggleStatus',
        JSON.stringify(locationToggleStatus)
      );
      this.initializeState();
    }
    if (!updateCppPending && prevProps.updateCppPending) {
      if (updateCppError) {
        this.cppFailedToast();
      } else {
        this.cppToast();
        this.setState(ps => ({
          cppDirty: false,
          originalOptOuts: ps.privacyProtectionOptOuts
        }));
      }
    }
  }

  onBackButtonClickHandler = () => {
    const {subscriptionData, selectedPlanId, isBulkSubscribed} = this.props.additionalData;
    this.props.setScreen({
      screen: screens.MANAGE_INTEGRATION,
      solutionData: this.props.solutionData,
      additionalData: {
        isAppNotListed: this.props.solutionData?.isAppNotListed,
        subscriptionData: subscriptionData,
        selectedPlanId : selectedPlanId,
        isBulkSubscribed
      },
    });
  };

  notAlreadyDisabled = (status) => {
    return status !== METADATA_CONSTANTS.STATUS.DISABLED;
  };

  notAlreadyEnabled = (status) => {
    return status !== METADATA_CONSTANTS.STATUS.ENABLED;
  };

  isPending = (status, requested_status) => {
    return status ? !status.includes(requested_status) : true;
  };

  getNewCppOptOuts = () => {
    const optOuts = this.state.privacyProtectionOptOuts;
    const { additionalData } = this.props;

    const expandedOptOuts = {};
    for (const [orgId, optOut] of Object.entries(optOuts)) {
      expandedOptOuts[orgId] = {
        [additionalData.apiDetails.id]: optOut
      };
    }

    return expandedOptOuts;
  };

  getLocationsToBeEnabled = (locations) => {
    return locations.filter(
      (location) =>
        location.requested_status ===
          METADATA_CONSTANTS.REQUESTED_STATUS.ENABLE &&
        this.notAlreadyEnabled(location.status) &&
        !location.disabled
    );
  };

  getLocationsToBeDisabled = (locations) => {
    return locations.filter(
      (location) =>
        location.requested_status ===
          METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE &&
        this.notAlreadyDisabled(location.status) &&
        !location.disabled
    );
  };

  createConsentPayloadForMultipleLocations = (args) => {
    const { solution, consentData = {}, provider, enabledEntityIds, asyncIntegrationId } = args;
    const {
      rejectionReason = null,
      signedTermsAndConditions = null,
    } = consentData;

    const { addendumDoc = null, id, api } = provider;

    const {
      id: solutionId,
      listingVersion = '1',
    } = solution;
    let version;
    if(!solution.isAppNotListed){
      version =solution.overview.version
    }

    let consentPayloadForMultipleLocations = {
      documentLink: addendumDoc,
      customConsentForm: solution.custom_consent && (!solution.custom_consent.selectedApis || solution.custom_consent.selectedApis.includes(this.props.additionalData.apiDetails.api.replace('api-v2-',''))) && solution.custom_consent.customConsentForm,
      solutionId: solutionId,
      listingVersion: listingVersion,
      solutionVersion: version ? version : null,
      reasonForRejection: rejectionReason,
      status: consentConstant.CONSENT_ACCEPTED,
      consentType: consentConstant.CONSENT_TYPE.API_DATA,
      subscriptionStatus: consentConstant.SUBSCRIPTION_STATUS_COMPLETED,
      consentedSource: consentConstant.CONSENTED_SOURCE,
      signedTermsAndConditions: signedTermsAndConditions,
      enabledEntityIds: enabledEntityIds,
      api: api,
      apiProviderId: id,
      apiType: this.props.additionalData.apiDetails.apiType || '',
      asyncIntegrationId
    }
    return consentPayloadForMultipleLocations;
  };

  consentForApiAddendumForMultipleLocations = async (args) => {
    const consent = this.createConsentPayloadForMultipleLocations(args);
    const { solution, token , enabledEntityIds} = args;
    let entityIds = enabledEntityIds.map((entity)=>entity.entityId);
    let allLocations = JSON.parse(localStorage.getItem('state')).loginDetailsSlice.allLocations;
    let businessNames = [];
    allLocations.forEach((loc)=>{
      entityIds.forEach((entityId)=>{
        if(loc.entityId === entityId){
        businessNames.push(loc.partyName);
        }
      })
    })
    let {firstName,lastName,sub:userEmail} = this.props.decodedToken;
    let businessRoleData = await this.props.getUserDetailsForBulkConnection({
      firstName,lastName,userEmail,token
    });
    if(businessRoleData && businessRoleData.payload && businessRoleData.payload.data){
      businessRoleData.payload.data.dealershipName = (businessNames && Array.isArray(businessNames) && businessNames.length>0)?businessNames.toString():null;
      consent.businessRoleData = businessRoleData.payload.data;
    }
    return await this.props.saveApiConsentForMultipleLocations({
      solution,
      consent,
      token,
    });
  };

  createData = async ({consentData, token, enabledEntityIds, asyncIntegrationId}) => {

    if(enabledEntityIds.length > 0)
    {
      this.consentForApiAddendumForMultipleLocations({
        solution: this.props.solutionData,
        consentData,
        provider: this.props.additionalData.apiDetails,
        token: token,
        enabledEntityIds,
        asyncIntegrationId
      });
    }
    await this.handleSave();
  }

  createIntegrationsData = ({solution, consentData, provider, token, enabledEntityIds, asyncIntegrationId}) => {
    return this.createData.bind(this, {solution, consentData, provider, token, enabledEntityIds, asyncIntegrationId});
  }

  saveApiConsentForMultipleLocations = async (consentData) => {
    this.setState({ showAPIAddendum: false });

    const { locations } = this.state;
    const locationsToBeEnabled = this.getLocationsToBeEnabled(locations);
    let enabledEntityIds = [];
    if (locationsToBeEnabled.length > 0) {
      enabledEntityIds = locationsToBeEnabled.map((location) => ({
        entityId: location.entityId,
        cmfNumber: location.entitycmfNumber,
      }));
    }

    this.setState({enabledEntityIds : enabledEntityIds.length})

    let asyncIntegrationId ;
    if(!this.props.solutionData.isAppNotListed){
      const { registration_details: { api_details } } = this.props.solutionData;
      const {
        id
      } = this.props.additionalData.apiDetails;

      let selectedAPI = api_details && api_details.filter(apiDetails => apiDetails && apiDetails.id === id);
      asyncIntegrationId = selectedAPI && Array.isArray(selectedAPI) && selectedAPI[0] && selectedAPI[0].asyncIntegrationId;
    }
    let integrationHandler = this.createIntegrationsData({
      solution: this.props.solutionData,
      consentData,
      provider: this.props.additionalData.apiDetails,
      token: this.props.token,
      enabledEntityIds,
      asyncIntegrationId: asyncIntegrationId || ""
    });

    this.setState({
       integrationHandler: integrationHandler,
       showAPIAddendum: false
    });

    if(this.state.doesApiRequireDMS &&  this.props.additionalData.isNewApi) {
      this.setState({
        showDmsSelection: true
      });
    }
    else {
      integrationHandler();
    }
  };

  isCppDirty = newOptOuts => {
    let cppDirty = false;
    for (const [orgId, optOut] of Object.entries(this.state.originalOptOuts)) {
      if (newOptOuts[orgId] !== optOut) {
        // we changed this cpp entry since we loaded the page.
        // a result of this is that cpp is always considered dirty once a new
        // location (with no existing cpp config for it) has been touched.
        cppDirty = true;
      }
    }
    return cppDirty;
  };

  handleCppToggle = (entityId, newStatus) => {
    const optOuts = { ...this.state.privacyProtectionOptOuts };
    optOuts[entityId] = newStatus;

    this.setState({
      privacyProtectionOptOuts: optOuts,
      cppDirty: this.isCppDirty(optOuts)
    });
  };

  handleCppToggleAll = () => {
    const optOuts = { ...this.state.privacyProtectionOptOuts };
    const newState = !Object.values(optOuts).every(oo => oo);
    for (const orgId of Object.keys(optOuts)) {
      optOuts[orgId] = newState;
    }
    this.setState({
      privacyProtectionOptOuts: optOuts,
      cppDirty: this.isCppDirty(optOuts)
    });
  };

  handleChange = (e, selectedIndex) => {
    let locationToggleStatus = JSON.parse(
      localStorage.getItem('locationToggleStatus')
    );
    let flag = 0;
    let connectionsDirty = false;
    let subscribedLocations = JSON.parse(JSON.stringify(this.state.locations));
    const locations = subscribedLocations.map((location, index) => {
      if (index === selectedIndex) {
        let foundIndex = locationToggleStatus.findIndex(
          (item) => item.locationIndex === selectedIndex
        );
        locationToggleStatus[foundIndex] = {
          locationIndex: index,
          toggleStatus: e.target.checked,
          isRequestSent: locationToggleStatus[index].isRequestSent,
        };
        location.requested_status =
          location.requested_status ===
          METADATA_CONSTANTS.REQUESTED_STATUS.ENABLE
            ? METADATA_CONSTANTS.REQUESTED_STATUS.DISABLE
            : METADATA_CONSTANTS.REQUESTED_STATUS.ENABLE;
      }
      if (this.isPending(location.status, location.requested_status)) {
        flag = 1;
      }
      return location;
    });
    if (flag > 0) {
      connectionsDirty = true;
    }
    localStorage.setItem(
      'locationToggleStatus',
      JSON.stringify(locationToggleStatus)
    );
    this.setState({
      locations,
      connectionsDirty
    });
  };

  handleSave = async () => {
    this.setState({
      loading: true
    });
    let locationToggleStatus = JSON.parse(
      localStorage.getItem('locationToggleStatus')
    );
    const { locations } = this.state;
    const solutionId = this.props.solutionData.id;
    const {
      apiDisplayName = '',
      api,
      id,
    } = this.props.additionalData.apiDetails;
    const token = this.props.token;
    const selectedPlanId = this.props.additionalData.selectedPlanId;


    let consentedEntityId = '';
    let asyncIntegrationId;
    if(!this.props.solutionData.isAppNotListed){
      const { registration_details: { api_details } } = this.props.solutionData;
      let selectedAPI = api_details && api_details.filter(apiDetails => apiDetails && apiDetails.id === id);
      asyncIntegrationId = selectedAPI && Array.isArray(selectedAPI) && selectedAPI[0] && selectedAPI[0].asyncIntegrationId;
    }

    if (this.state.doesApiSupportCpp) {
      await this.props.updateCppForApp({
        appId: solutionId,
        optOuts: this.getNewCppOptOuts(),
        locations,
        cppSupportedApis: [id],
        token
      });
    }

    const payload = {
      email: this.props.email,
      firstName: this.props.decodedToken.firstName,
      lastName: this.props.decodedToken.lastName,
      solutionId: solutionId,
      api,
      apiProviderId: id,
      apiDisplayName,
      consentType: METADATA_CONSTANTS.CONSENT_TYPE.CONNECTION,
      selectedPlanId,
      consentedEntityId,
      apiType: this.props.additionalData.apiDetails.apiType || '',
      asyncIntegrationId: asyncIntegrationId || ""
    };
    const locationsToBeDisabled = this.getLocationsToBeDisabled(locations);
    const locationsToBeEnabled = this.getLocationsToBeEnabled(locations);
    if (locationsToBeEnabled.length > 0) {
      if(this.props.additionalData.isBulkSubscribed){
        payload.isBulkSubscribed = true;
        payload.connectionIds = locationsToBeEnabled.map(loc => loc.connectionId);
        const entityList = locationsToBeEnabled.map(location => location.entityId);
        payload.entityIdList = entityList;
        let entityIdSubscriptionIdMapping = locationsToBeEnabled.map(location => ({
          entityId: location.entityId,
          subscriptionId: location.subscriptionId
        }));
        payload.entityIdSubscriptionIdMapping = entityIdSubscriptionIdMapping;
      }
      else{
      const entityList = locationsToBeEnabled.map((location) => ({
        entityId: location.entityId,
        entitycmfNumber: location.entitycmfNumber,
      }));
      payload.entityIdList = entityList;
    }
      this.setState({ enabledLocations: locationsToBeEnabled.length, enablePayload : payload });
    }
    if (locationsToBeDisabled.length > 0) {
      let disablePayload = JSON.parse(JSON.stringify(payload));
      if(this.props.additionalData.isBulkSubscribed){
        disablePayload.isBulkSubscribed = true;
        disablePayload.connectionIds = locationsToBeDisabled.map(loc => loc.connectionId);
        const entityList = locationsToBeDisabled.map(location => location.entityId);
        disablePayload.entityIdList = entityList;
      }
      else{
      const entityList = locationsToBeDisabled.map(
        (location) => location.entityId
      );
      disablePayload.entityIdList = entityList;
      }
      this.setState({ disabledLocations: locationsToBeDisabled.length });
      if(locationsToBeEnabled.length === 0)
      {
        this.props.bulkConnectionDisable({ payload:disablePayload, token });
      }
      else{
        this.setState({disablePayload:disablePayload})
      }
    }
    locationToggleStatus.forEach((item, index) => {
      if (item && item.toggleStatus !== '') {
        locationToggleStatus[index] = {
          locationIndex: item.locationIndex,
          toggleStatus: item.toggleStatus,
          isRequestSent: true,
        };
      }
    });

    if (!(locationsToBeEnabled.length || locationsToBeDisabled.length)) {
      // cpp change only. drop the loading cover.
      this.setState({
        loading: false
      });
    }

    localStorage.setItem(
      'locationToggleStatus',
      JSON.stringify(locationToggleStatus)
    );
    this.setState({
      connectionsDirty: false
    });
  };

  onSave = async () => {
    const {solutionData, additionalData} = this.props;
    sendAmplitudeData(AMPLITUDE_EVENTS.MANAGE_INTEGRATIONS, {
      [AMPLITUDE_PROPERTIES.APP_NAME]:
        solutionData?.overview?.name || solutionData?.displayName,
      [AMPLITUDE_PROPERTIES.APP_ID]: solutionData?.id,
      [AMPLITUDE_PROPERTIES.API_ID]: additionalData?.apiDetails?.id,
      [AMPLITUDE_PROPERTIES.API_NAME]:
        additionalData?.apiDetails?.apiDisplayName ||
        additionalData?.apiDetails?.name,
    });
    const { apiProviders = [] } = this.props.ApiIntegrationsDetails;
    const { apiDisplayName = '' } = additionalData.apiDetails;
    let apiProviderDetails;
    apiProviders.forEach((apiProvider) => {
      if (apiProvider.apiDisplayName === apiDisplayName)
        apiProviderDetails = apiProvider;
    });
    const { locations } = this.state;
    const locationsToBeEnabled = this.getLocationsToBeEnabled(locations);
    if (locationsToBeEnabled.length > 0) {
      let apiId = this.props.additionalData.apiDetails.id;
      let dmsApiDetails = this.props && this.props.dmsApiDetails && this.props.dmsApiDetails[apiId] && this.props.dmsApiDetails[apiId][0];

      this.setState({ dmsApiDetails:dmsApiDetails, locationsToBeEnabled:locationsToBeEnabled,  showAPIAddendum: true, provider: apiProviderDetails });
    } else {
      await this.handleSave();
    }
  };

  onDMSClose = (success) => {
    this.setState({showDmsSelection: false});
    if(!success) return;
    this.state.integrationHandler();
  }

  onDMSSelected = (dmsData) => {
    this.setState({showDmsSelection: false, dmsData: dmsData});
    this.state.integrationHandler();
  }

  buildLocationData = () => {
    let locationToggleStatus = JSON.parse(
      localStorage.getItem('locationToggleStatus')
    );
    return this.state.locations.map((dealer, index) => {
      let {
        createdOn = 'NA',
        requested_status,
        disabled,
        entitycmfNumber,
        entityId,
        apiProvisioningStatus
      } = dealer;
      const isAsyncApi =
        this.props.additionalData.apiDetails.apiType === 'async-api';
      let partyName = '';

      this.props.allLocations.forEach((location) => {
        if (
          location.cmfNumber === entitycmfNumber ||
          location.entityId === entityId
        ) {
          partyName = location.partyName;
        }
      });

      const currentToggleStatus =
        locationToggleStatus && locationToggleStatus[index];
      let checkedStatus =
        requested_status === METADATA_CONSTANTS.REQUESTED_STATUS.ENABLE;
      if (currentToggleStatus && currentToggleStatus.toggleStatus !== '') {
        checkedStatus =
          currentToggleStatus.toggleStatus === true;
      }
      if (
        currentToggleStatus &&
        currentToggleStatus.toggleStatus !== '' &&
        currentToggleStatus.isRequestSent
      ) {
        disabled = true;
      }
      let updatedRequestedStatus = 'Disabled';
      if (
        requested_status === METADATA_CONSTANTS.REQUESTED_STATUS.ENABLE ||
        checkedStatus
      ) {
        updatedRequestedStatus = 'Enabled';
      }

      return {
        partyName,
        address: this.props.entityIdAddressMapping[entityId],
        createdOn,
        requested_status,
        disabled,
        toggleHandler: this.handleChange,
        index,
        checkedStatus,
        updatedRequestedStatus,
        cppSupported: this.state.doesApiSupportCpp,
        cppOptOut: this.state.privacyProtectionOptOuts[entityId],
        updateCppOptOut: e => this.handleCppToggle(entityId, e.target.checked),
        apiProvisioningStatus,
        isAsyncApi
      };
    });
  };

  render() {
    let {
      solutionData,
      disablePending,
      isApiIntegrationsDetailsPending,
      issaveApiConsentPending,
      enablePending,
      additionalData,
      decodedToken,
      email,
      getDMSInfoBasedOnApisPending,
      loadingOptOuts,
      updateCppPending
    } = this.props;

    let {
      connectionsDirty,
      cppDirty
    } = this.state;

    const isAsyncApi = additionalData.apiDetails.apiType === 'async-api';

    return (
      <Page>
        <SolutionHeader
          solutionData={solutionData}
          isAppNotListed={solutionData?.isAppNotListed}
          appName={solutionData?.displayName}
          publisherName={solutionData?.orgName}
          onBackButtonClickHandler={this.onBackButtonClickHandler}
          text="Back to Integrations"
        />
        {(isApiIntegrationsDetailsPending || getDMSInfoBasedOnApisPending || loadingOptOuts) && (
          <LoadingOverlaySpinner active={true} text="Loading Details" />
        )}

        {updateCppPending && (
          <LoadingOverlaySpinner active={true} text="Saving CPP selections" />
        )}

        {(
          disablePending
          || enablePending
          || issaveApiConsentPending
          || (this.state.loading && !updateCppPending)
        ) && (
          <LoadingOverlaySpinner
            active={true}
            text={SAVING_CONNECTION_UPDATE_MSG}
          />
        )}
        <div className="locations">
          <div className="locations__solution_header">
            <FormattedMessage
              id="Solution.Header"
              defaultMessage="Integrations"
            />
          </div>
          <div className="locations__solution_description">
            <FormattedMessage
              id="Solution.Description"
              defaultMessage="Enable or disable the API integration for this app."
            />
            {' '}
            <LearnMore
              docPath="/docs/marketplace/marketplace-for-apps/managing-app-configurations/#managing-api-integrations"
              screen="Manage Integrations"
            />
          </div>
          {this.state.doesApiSupportCpp && (
            <Notice
              id="locations__cpp-supported"
              content={(
                <>
                  This API supports Consumer Privacy Protection. Select the
                  Privacy Protection checkbox to limit customer data sharing
                  with the app publisher.
                </>
              )}
            />
          )}
          <div className="locations__container">
            <LocationsTable
              apiName={additionalData.apiDetails.apiDisplayName}
              locations={this.buildLocationData()}
              isAsyncApi={isAsyncApi}
              cppSupported={this.state.doesApiSupportCpp}
              handleCppToggleAll={this.handleCppToggleAll}
            />
          </div>
          <Button
            isDisabled={!(connectionsDirty || cppDirty)}
            className="secondary_button"
            onClick={this.onSave}
            text="Save"
          />
        </div>
        {this.state.showAPIAddendum ? (
          <ConsentDialog
            open={this.state.showAPIAddendum}
            onClose={() => {
              this.setState({
                showAPIAddendum: false
              });
            }}
            docUrl={solutionData.custom_consent && (!solutionData.custom_consent.selectedApis || solutionData.custom_consent.selectedApis.includes(additionalData.apiDetails.api.replace('api-v2-',''))) ? solutionData.custom_consent.customConsentForm : additionalData.apiDetails.addendumDoc}
            title={additionalData.apiDetails.name}
            termType={consentConstant.TERM_TYPE.API_TERMS}
            userInfo={decodedToken}
            onAccept={this.saveApiConsentForMultipleLocations}
            provider={
              additionalData.apiDetails ? additionalData.apiDetails : {}
            }
            type="api"
            email={email}
            token={this.props.token}
            oneClickConsentOnly={solutionData.custom_consent && (!solutionData.custom_consent.selectedApis || solutionData.custom_consent.selectedApis.includes(additionalData.apiDetails.api.replace('api-v2-',''))) ? true : false}
          />
        ) : null}
        {
          this.state.showDmsSelection &&  (
            <div>
              <Overlay
                active={this.state.showDmsSelection}
                title="Verify DMS accounts"
                onOverlayClose={() => this.setState({showDmsSelection: false})}
                customeStyle={{height: '70vh', width: '70vw'}}
                secondButtonText="Save"
                hideFirstButton={true}
                hideSecondButton={true}
                className="new-api-dms-dialog"
              >
                <DMSSelection
                  disableNextButton ={() => {}}
                  solutionData={solutionData}
                  solutionId={solutionData && solutionData.id}
                  navigatedFromApiIntegrations ={true}
                  isNewApi={true}
                  apiId={additionalData && additionalData.apiDetails && additionalData.apiDetails.id}
                  onClose={this.onDMSClose}
                  dmsApiDetails={this.state.dmsApiDetails}
                  locationsToBeEnabled={this.state.locationsToBeEnabled}
                  isBulkSubscribed={this.props.additionalData.isBulkSubscribed}
                  isAsyncApi={this.props.additionalData?.apiDetails?.apiType === "async-api"}
                  onDMSSelected={this.onDMSSelected}
                />
              </Overlay>
            </div>
          )
        }
        <MultiToasts
          position={TOAST_POSITIONS.FIXED}
          style={{ marginTop: '70px' }}
          items={this.state.toasts}
        />
      </Page>
    );
  }
}

const mapStateToProps = (state = {}) => ({
  ApiIntegrationsDetails:
    state?.apiIntegrationSlice?.ApiIntegrationsDetails,
  allLocations:
    state?.loginDetailsSlice?.allLocations,
  entityIdAddressMapping:
    state?.loginDetailsSlice?.entityIdAddressMapping,
  token: state?.loginDetailsSlice?.authenticationToken,
  decodedToken: state?.loginDetailsSlice?.decodedToken,
  email: state?.loginDetailsSlice?.userEmail,
  issaveApiConsentSuccess: state?.manageBulkConnectionsSlice?.issaveApiConsentSuccess,
  disableSuccess: state?.manageBulkConnectionsSlice?.disableSuccess,
  disablePending: state?.manageBulkConnectionsSlice?.disablePending,
  disableFailed: state?.manageBulkConnectionsSlice?.disableFailed,
  issaveApiConsentPending: state?.manageBulkConnectionsSlice?.issaveApiConsentPending,
  issaveApiConsentFailed: state?.manageBulkConnectionsSlice?.issaveApiConsentFailed,
  enableSuccess: state?.manageBulkConnectionsSlice?.enableSuccess,
  enablePending: state?.manageBulkConnectionsSlice?.enablePending,
  enableFailed: state?.manageBulkConnectionsSlice?.enableFailed,
  isApiIntegrationsDetailsPending: state?.apiIntegrationSlice?.isApiIntegrationsDetailsPending,
  createConsentSuccess: state?.manageBulkConnectionsSlice?.createConsentSuccess,
  iscreateApiTermsConsentPending: state?.manageBulkConnectionsSlice?.iscreateApiTermsConsentPending,
  dmsApiDetails: state.selectDMSSlice?.dmsApiDetails || {},
  privacyProtectionSupported: state.selectDMSSlice?.privacyProtectionSupported || {},
  getEISDMSInfo: state.selectDMSSlice?.getEISDMSInfo || [],
  getDMSInfoBasedOnApisPending: state.selectDMSSlice?.getDMSInfoBasedOnApisPending,
  DMSConfigInfo: state.selectDMSSlice && state.selectDMSSlice.DMSConfigInfo,
  selectedDMS: state.selectDMSSlice?.selectedDMS,
  optOutsByLocation: state.privacyProtectionSlice?.optOutsByLocation || {},
  loadingOptOuts: state.privacyProtectionSlice?.loadingOptOuts,
  loadingOptOutsError: state.privacyProtectionSlice?.loadingOptOutsError,
  updateCppPending: state.privacyProtectionSlice?.updateCppPending,
  updateCppError: state.privacyProtectionSlice?.updateCppError,
});

const mapDispatchToProps = {
  setScreen,
  bulkConnectionDisable,
  bulkConnectionEnable,
  saveApiConsentForMultipleLocations,
  getApiIntegrationsDetails,
  updateConsentSuccess,
  updateConsentfailed,
  updateSaveConsentSuccess,
  getUserDetailsForBulkConnection,
  clearUpdateDMSAccounts,
  clearSelectedDMS,
  updateSelectedDMSAccounts,
  getDMSAccountDetailsFromEIS,
  getDMSInfoBasedOnApis,
  getCppForAppAndLocations,
  updateCppForApp
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageBulkConnections)
);
